import React from 'react';
import {Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle} from 'react-bootstrap';

export interface CommonConfirmDeleteModalProps {
    commentsToDelete: number;
    onConfirm: () => void;
}

type InnerConfirmDeleteModalProps = CommonConfirmDeleteModalProps & {
    visible: boolean;
    close: () => void;
};

export interface CommonConfirmDeleteModalState {
    visible: boolean;
}

export default class ConfirmDeleteModal extends React.Component<InnerConfirmDeleteModalProps, {}> {

    constructor(props: InnerConfirmDeleteModalProps) {
        super(props);

        this.handleDelete = this.handleDelete.bind(this);
    }

    handleDelete() {
        this.props.onConfirm();
        this.props.close();
    }

    render() {
        return (
            <Modal show={this.props.visible} onHide={this.props.close}>
                <ModalHeader>
                    <ModalTitle>Slett kommentar</ModalTitle>
                </ModalHeader>
                <ModalBody>
                    <p>Vennligst bekreft at du vil
                        slette {this.props.commentsToDelete} kommentar{this.props.commentsToDelete === 1 ? '' : 'er'}.</p>
                </ModalBody>
                <ModalFooter>
                    <Button bsStyle="default" onClick={this.props.close}>Avbryt</Button>
                    <Button bsStyle="primary" onClick={this.handleDelete}>OK</Button>
                </ModalFooter>
            </Modal>
        );
    }
}
